export default "__VITE_ASSET__3359a35f__"